export enum VoiType {
    CarsAndMinivans = "Cars & Minivans",
    Trucks = "Trucks",
    CrossoversAndSUVs = "Crossovers & SUVs"
}
